import { useRouter } from 'next/router';

import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { SubTitle, Title } from './style';

import Image from '@components/atoms/image';
import { getNamespaces } from '@helpers/i18nUtils';
import { useBreakpoint, useDegreeLandingPageData } from '@helpers/use';

export const TotalExpenseSection = () => {
  const { isMobile } = useBreakpoint();
  const router = useRouter();
  const degreeIdName = (router.query.degreeIdName as string) || '';
  const { t } = useTranslation(getNamespaces({ namespaces: [degreeIdName] }));

  const universityId = router.query.universityIdName as string;

  const { landingPage } = useDegreeLandingPageData(universityId, degreeIdName);

  return (
    <Box>
      {landingPage && (
        <>
          <Box mb={5}>
            <Title>{t('degree_landing_page.degree_struct.tuition_fees.title')}</Title>
            <SubTitle>{t('degree_landing_page.degree_struct.tuition_fees.subtitle')}</SubTitle>
          </Box>
          {isMobile ? (
            <Image src={landingPage.tuitionFeesMobileImageUrl} alt="Degree tuition fees" />
          ) : (
            <Image src={landingPage.tuitionFeesImageUrl} alt="Degree tuition fees" />
          )}
        </>
      )}
    </Box>
  );
};
